import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { Card } from "src/base-components/Card";
import { AutocompleteCodeInput } from "src/base-components/CodeInput/EditorCodeInput";
import { AgentNodeData } from "src/constants/NodeDataTypes";

type Props = {
  immutable: boolean;
};

export const AgentNodeResponseMapping: React.FC<Props> = ({ immutable }) => {
  const { control } = useFormContext<AgentNodeData>();

  return (
    <Card className="flex w-full flex-col gap-y-3">
      <div className="text-gray-800 font-inter-semibold-13px">
        Output location
      </div>
      <div className="text-gray-500 font-inter-normal-12px">
        Specify where the agent's response should be stored in the data object.
      </div>
      <Controller
        control={control}
        name="response.default.mapped_to"
        render={({ field: controlledField }) => (
          <AutocompleteCodeInput
            dataLoc="agent-node-response-mapped-to"
            disabled={immutable}
            placeholder="agent_response"
            prefix="data."
            value={controlledField.value}
            onChange={controlledField.onChange}
          />
        )}
      />
    </Card>
  );
};
